module.exports = __webpack_public_path__ + "facebook.svg?8ba6f26ea649da88c71e082c90b9b636";